<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-card tile flat>
            <v-card-text>
                <v-list subheader>
                    <v-list-item @click = "visibility.create=true" v-if = 'reportCreateAllowed'>
                        <v-list-item-content>
                            <v-list-item-title>Создать отчет</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon class='mx-auto'>add</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-progress-linear :color='$store.getters.uiAccent' class='mb-0 py-0 mt-0' height='1' :active='indicator' :indeterminate='true'></v-progress-linear>
                    <v-divider v-if = '!indicator'></v-divider>
                    <v-list-item link v-if='!reports.length && !indicator'>
                        <v-list-item-content>
                            <v-list-item-title>Отчеты не подключены</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if='!reports.length && !indicator'></v-divider>
                    <v-list-item 
                      v-for='(s,si) in reports' 
                      :key='`report_${s.report_id}`' 
                      :to="{ name: 'report', params: {'report_id': s.report_id} }" target='_blank' 
                      style='border-bottom: 1px solid;border-color:#EEEEEE;'
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{s.name}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class = 'pa-0 ma-0' v-if = 's.is_client'>
                            <v-chip small disabled class = 'mr-1'>Клиентский</v-chip>
                        </v-list-item-action>
                        <v-list-item-action v-if = '!s.active' class = 'mr-2'>
                            <v-chip small outlined disabled class = 'mr-1'>В архиве</v-chip>
                        </v-list-item-action>
                        <v-list-item-action v-if = 'reportUpdateAllowed' class = 'mr-1'>
                            <v-tooltip bottom>
                                <template v-slot:activator = '{ on }'>
                                    <v-btn v-on = 'on' small class='mx-auto' icon @click.stop.prevent = 'cursorReport = s; visibility.archive = true;'>
                                        <v-icon small color='amber accent-3'>
                                            {{s.active? "mdi-arrow-down-bold-box-outline":"mdi-arrow-up-bold-box-outline"}}
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{s.active? "Архивировать":"Разархивировать"}}</span>
                            </v-tooltip>
                        </v-list-item-action>
                        <v-list-item-action v-if = 'reportUpdateAllowed' class = 'mx-1'>
                            <v-tooltip bottom>
                                <template v-slot:activator = '{ on }'>
                                    <v-btn v-on = 'on' small class='mx-auto' icon @click.stop.prevent = 'cursorReport = s; visibility.update = true;'>
                                        <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Редактировать</span>
                            </v-tooltip>
                        </v-list-item-action>
                        <v-list-item-action v-if = 'reportDeleteAllowed' class = 'ml-1'>
                            <v-tooltip bottom>
                                <template v-slot:activator = '{ on }'>
                                    <v-btn v-on = 'on' small class='mx-auto' icon @click.stop.prevent = 'cursorReport = s; visibility.delete = true;'>
                                        <v-icon small :color='$store.getters.uiAccentIcon'>delete_outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Удалить</span>
                            </v-tooltip>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
        <report-create :initialState.sync = 'visibility.create' :flowAdd='false' :postAction='getProjectReports' :project='project'></report-create>
        <report-update :initialState.sync = 'visibility.update' :data = 'cursorReport' :postAction = 'getProjectReports'></report-update>
        <report-archive :initialState.sync = 'visibility.archive' :data = 'cursorReport' :postAction = 'getProjectReports'></report-archive>
        <report-delete :initialState.sync = 'visibility.delete' :data='cursorReport' :postAction='getProjectReports' :purgeReport='true'></report-delete>
    </v-layout>
</template>

<script>

import CreateReport from '@/components/entities/reports/CreateDialog.vue'
import DeleteReport from '@/components/entities/reports/DeleteDialog.vue'
import ArchiveReport from '@/components/entities/reports/ArchiveDialog.vue'
import UpdateReport from '@/components/entities/reports/UpdateDialog.vue'

import projectHandlers from '@/mixins/project'
import { orderBy } from 'lodash-es'

export default {
    name: 'ProjectReports',
    props: ['data'],
    mixins: [projectHandlers],
    components: {
        'report-create': CreateReport,
        'report-update': UpdateReport,
        'report-delete': DeleteReport,
        'report-archive': ArchiveReport
    },
    data() {
        return {
            visibility: {
                update: false,
                create: false,
                delete: false,
                archive: false
            },
            project: this.data,
            reports: [],
            cursorReport: {},
            indicator: false,
            valid: false,
            rules: {
                required: value => !!value || 'Обязательное поле.'
            }
        }
    },
    computed: {
        reportCreateAllowed() {
            return ['X', 'U'].includes(this.project.mode_reports)
        },
        reportUpdateAllowed() {
            return ['X', 'U'].includes(this.project.mode_reports)
        },
        reportDeleteAllowed() {
            return ['X', 'U'].includes(this.project.mode_reports)
        }
    },
    watch: {
        data: {
            handler (value) {
                this.project = value
                this.reports = []
                this.getProjectReports()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getProjectReports() {
            this.indicator = true;
            this.getProjectPropertyPromise('reports').then((r) => {
                let response = r.body
                this.indicator = false
                if (response.result) {
                    this.reports = orderBy(response.data || [], 'report_name');
                } else {
                    console.log('error fetch project reports', response.data)
                }
            });
        }
    }
}
</script>